import { Typography } from '@mui/material';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import ToggleOffIcon from '@mui/icons-material/ToggleOff';

import type { TimelineItem } from '../HistoryDialog.types.ts';
import { TimelineItemSection } from '../TimelineItemSection.tsx';

type ToggleDisabledActionProps = {
  item: TimelineItem<'TOGGLE_DISABLED'>;
};

export const ToggleDisabledAction: React.FC<ToggleDisabledActionProps> = ({ item }) => {
  if (item.action !== 'TOGGLE_DISABLED') {
    return null;
  }

  if (!item.metadata) {
    return null;
  }

  const { isDisabled } = item.metadata;

  const title = isDisabled ? 'Step disabled' : 'Step enabled';
  const Icon = isDisabled ? ToggleOffIcon : ToggleOnIcon;

  return (
    <TimelineItemSection
      title={title}
      Icon={Icon}
      flexDirection="row"
      justifyContent="space-between"
      sx={{ color: isDisabled ? 'secondary.main' : 'success.main' }}
    >
      <Typography variant="caption">{isDisabled ? 'Step has been disabled' : 'Step has been enabled'}</Typography>
    </TimelineItemSection>
  );
};
